<template>
  <b-modal id="members" size="lg" title="Members" hide-footer>
    <div class="px-3 mb-3 modal-form">
      <b-row>
        <b-col cols="3">
          <b-form-select v-model="selectedFilter" :options="filterOptions" @input="filterMembers()"></b-form-select>
        </b-col>
        <b-col id="members-filter-wrapper">
          <div class="filter-wrapper">
            <b-input-group prepend>
              <b-form-input
                @keyup.native="search"
                placeholder="Search"
                v-model="searchString"
              ></b-form-input>
              <b-dropdown text="Advanced" variant="primary" slot="append">
                <b-dropdown-item
                  v-for="searchField in searchableFields"
                  :key="searchField.value"
                  @click="searchOption(searchField.value)"
                >
                  {{ searchField.text }}
                  <i
                    v-if="selectedSearchOption === searchField.value"
                    class="ml-1"
                  >
                    <img
                      width="15"
                      height="15"
                      src="@/assets/images/checked-symbol.svg"
                      alt
                      class="mr-1"
                      style="margin-top: -2px; margin-right: 0px;"
                    />
                  </i>
                </b-dropdown-item>
              </b-dropdown>
            </b-input-group>
          </div>
        </b-col>
        <b-col class="text-right" cols="3"><b-button variant="primary btn-table-export" @click="exportMembers()">Export</b-button></b-col>
      </b-row>
    </div>
    <div class="members-container">
      <b-table
        :items="isSearchType ? [] : members"
        :fields="membersFields"
        bordered
        show-empty
        :empty-text="(loading) ? 'Loading data' : emptyText"
      >
        <template slot="type" slot-scope="data">
          <p class="text-capitalize m-0">{{ data.value }}</p>
        </template>
        <template slot="expired_at" slot-scope="data">
          {{ format_date(data.value) }}
        </template>
        <template slot="status" slot-scope="data">
          <template v-if="check_if_expired(data.item.expired_at)">
            <div class="inactive-status">Expired</div>
          </template>
          <template v-else>
            <div v-if="data.value == 'active'" class="active-status">Active</div>
            <div class="inactive-status" v-else>Inactive</div>
          </template>
        </template>
      </b-table>
    </div>
    <div class="px-3">
      <b-row>
        <b-col>
          <div>
            <span
              class="pagination-indicator"
            >Showing {{ membersCurrentFirstItem }} to {{ membersCurrentLastItem }} of {{ membersMaxPage}} pages</span>
          </div>
        </b-col>
        <b-col>
          <b-pagination
            hide-goto-end-buttons
            align="right"
            size="md"
            :total-rows="(membersTotalPerPage > 0 ) ? membersMaxPage * membersTotalPerPage : 1"
            :limit="(membersTotalPerPage > 0 ) ? 5 : 1"
            :per-page="membersTotalPerPage"
            @change="membersPaginate"
            class="custom-pagination"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import moment from 'moment';

export default {
  name: "members",
  props: ["members", "purchasePackageUuid"],
  data() {
    return {
      membersFields: [
        { key: "card_id", label: "Member ID", sortable: true },
        { key: "customer_name", label: "Name", sortable: true },
        { key: "type", label: "Card Type", sortable: true },
        { key: "expired_at", label: "Expiration", sortable: true },
        { key: "status", label: "Status", sortable: true }
      ],
      selectedFilter: "all",
      filterOptions: [
        { value: "all", text: "All Status" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" },
        { value: "digital", text: "Digital" },
        { value: "physical", text: "Physical" }
      ],
      searchString: "",
      searchableFields: [
        { value: "all", text: "All" },
        { value: "name", text: "Name" },
        { value: "card_no", text: "Card No." }
      ],
      selectedSearchOption: "all",
      isSearchType: false,
      emptyText: "No Records Found",
    };
  },
  computed: {
    ...mapState("purchasePackages", [
      "loading",
      "membersMaxPage",
      "membersNextPage",
      "membersPrevPage",
      "membersCurrentPage",
      "membersTotalPerPage",
      "membersCurrentFirstItem",
      "membersCurrentLastItem",
      "membersInitialPageCount"
    ])
  },
  methods: {
    async getMembers(page) {
      let param = {
        page: page,
        payload: {
          package_uuid: this.purchasePackageUuid,
          search: this.selectedSearchOption,
          filter: this.selectedFilter,
          keyword: this.searchString
        }
      };
      if (this.searchString.trim() === "") {
        delete param.payload.keyword;
        delete param.payload.search;
      }
      await this.$store.dispatch("purchasePackages/getMembers", param);
    },
    membersPaginate(page) {
      return this.getMembers(page);
    },
    filterMembers() {
      this.$store.dispatch("purchasePackages/resetMembersPagination");
      this.getMembers(1);
    },
    format_date(value){
        if (value) {
          return moment(String(value)).format('D MMMM Y')
        }
    },
    check_if_expired(value) {
      return moment(value).isBefore(new Date());
    },
    search() {
      let param = {
        payload: {
          package_uuid: this.purchasePackageUuid,
          search: this.selectedSearchOption,
          filter: this.selectedFilter,
          keyword: this.searchString
        },
        page: 1
      };

      if (this.searchString.trim() === "") {
        return this.getMembers(1);
      }
      
      this.emptyText = "Searching...";
      this.isSearchType = true;
      
      let _this = this;
      this.$store.dispatch("purchasePackages/getMembers", param).then(() => {
        _this.emptyText = 'No Records Found for "' + _this.searchString + '"';
        _this.isSearchType = false;
      });
    },
    searchOption(value) {
      this.selectedSearchOption = value;
      if (this.searchString.trim() !== "") {
        this.search();
      }
    },
    async exportMembers() {
      let param = {
        payload: {
          package_uuid: this.purchasePackageUuid,
          search: this.selectedSearchOption,
          keyword: this.searchString
        }
      };

      if (this.searchString.trim() === "") {
        delete param.payload.keyword;
        delete param.payload.search;
      }

      await this.$store.dispatch(
        "purchasePackages/exportMembers",
        param
      );
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      this.selectedSearchOption = "";
      this.selectedFilter = "all";
      this.searchString = "";
      this.emptyText = "No Records Found";
    })
  }
};
</script>
<style lang="scss">
#members-filter-wrapper {
  .filter-wrapper .input-group {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    .form-control {
      height: 36px;
    }
    .dropdown-toggle {
      height: 36px;
    }
  }
}
</style>